import { SelectLanguageController } from "./select-language.controller";

angular.module("thor.shared.translations.select-language.component", []).component("selectLanguage", {
    bindings: {
        languages: "<",
        selectedLanguage: "=",
        sourceLang: "<?"
    },
    controller: SelectLanguageController,
    template: require("../../shared/translations/select-language.html")
});
